// Affiliate disclosure. Anywhere a visitor can click out to a retailer, they
// should be able to see that we earn a commission on that click before they
// make it. Putting it in a footer or a terms page does not count. It lives in
// one component so the wording stays the same everywhere it shows up.
//
// Pass `retailer` when we know which shop the link goes to ("Amazon",
// "Currys"). Leave it out on pages that list several, and the copy stays
// general.

export function AffiliateDisclosure({
  retailer,
  className = "",
}: {
  retailer?: string | null;
  className?: string;
}) {
  return (
    <p className={`text-[11px] leading-relaxed text-muted-foreground ${className}`}>
      {retailer
        ? `We're an affiliate partner of ${retailer}, so if you buy through this link we get a commission. It costs you nothing extra.`
        : "We're affiliate partners with the shops we link to, like Amazon and Currys. If you buy through one of our links we get a commission. It costs you nothing extra."}
    </p>
  );
}
